<template>
    <div id="koronarokotepetokset">
      <section id="parallax-1" class="hero is-large">
          <div class="hero-body"  style="padding: 6rem 6rem;">
              <div class="container">
              <div class="columns">
                  <div class="column is-12 has-text-justified">
                    <h1 class="title">KORONAROKOTEPETOKSET</h1>
                    <!-- VIDEOT: lisää uusi video kopioimalla div ja vaihtamalla videon numero -->
                    <div class="videot">
                      <div class="video">
                        <iframe src="https://www.tiktok.com/player/v1/7651254871831661846?description=1&rel=0" loading="lazy" allow="fullscreen; encrypted-media; picture-in-picture" allowfullscreen title="Jaana Kavonius TikTok-video"></iframe>
                      </div>
                      <div class="video">
                        <iframe src="https://www.tiktok.com/player/v1/7651255610889014550?description=1&rel=0" loading="lazy" allow="fullscreen; encrypted-media; picture-in-picture" allowfullscreen title="Jaana Kavonius TikTok-video"></iframe>
                      </div>
                      <div class="video">
                        <iframe src="https://www.tiktok.com/player/v1/7651256933755735318?description=1&rel=0" loading="lazy" allow="fullscreen; encrypted-media; picture-in-picture" allowfullscreen title="Jaana Kavonius TikTok-video"></iframe>
                      </div>
                      <div class="video">
                        <iframe src="https://www.tiktok.com/player/v1/7651257390372883734?description=1&rel=0" loading="lazy" allow="fullscreen; encrypted-media; picture-in-picture" allowfullscreen title="Jaana Kavonius TikTok-video"></iframe>
                      </div>
                      <div class="video">
                        <iframe src="https://www.tiktok.com/player/v1/7651258710207040790?description=1&rel=0" loading="lazy" allow="fullscreen; encrypted-media; picture-in-picture" allowfullscreen title="Jaana Kavonius TikTok-video"></iframe>
                      </div>
                      <div class="video">
                        <iframe src="https://www.tiktok.com/player/v1/7651259188865158403?description=1&rel=0" loading="lazy" allow="fullscreen; encrypted-media; picture-in-picture" allowfullscreen title="Jaana Kavonius TikTok-video"></iframe>
                      </div>
                      <div class="video">
                        <iframe src="https://www.tiktok.com/player/v1/7651260131518254358?description=1&rel=0" loading="lazy" allow="fullscreen; encrypted-media; picture-in-picture" allowfullscreen title="Jaana Kavonius TikTok-video"></iframe>
                      </div>
                      <div class="video">
                        <iframe src="https://www.tiktok.com/player/v1/7651260549602331926?description=1&rel=0" loading="lazy" allow="fullscreen; encrypted-media; picture-in-picture" allowfullscreen title="Jaana Kavonius TikTok-video"></iframe>
                      </div>
                      <div class="video">
                        <iframe src="https://www.tiktok.com/player/v1/7651261502229466390?description=1&rel=0" loading="lazy" allow="fullscreen; encrypted-media; picture-in-picture" allowfullscreen title="Jaana Kavonius TikTok-video"></iframe>
                      </div>
                      <div class="video">
                        <iframe src="https://www.tiktok.com/player/v1/7651262036978060566?description=1&rel=0" loading="lazy" allow="fullscreen; encrypted-media; picture-in-picture" allowfullscreen title="Jaana Kavonius TikTok-video"></iframe>
                      </div>
                      <div class="video">
                        <iframe src="https://www.tiktok.com/player/v1/7651262924849237270?description=1&rel=0" loading="lazy" allow="fullscreen; encrypted-media; picture-in-picture" allowfullscreen title="Jaana Kavonius TikTok-video"></iframe>
                      </div>
                      <div class="video">
                        <iframe src="https://www.tiktok.com/player/v1/7651263883117743382?description=1&rel=0" loading="lazy" allow="fullscreen; encrypted-media; picture-in-picture" allowfullscreen title="Jaana Kavonius TikTok-video"></iframe>
                      </div>
                      <div class="video">
                        <iframe src="https://www.tiktok.com/player/v1/7651264238610107670?description=1&rel=0" loading="lazy" allow="fullscreen; encrypted-media; picture-in-picture" allowfullscreen title="Jaana Kavonius TikTok-video"></iframe>
                      </div>
                      <div class="video">
                        <iframe src="https://www.tiktok.com/player/v1/7651264941768396054?description=1&rel=0" loading="lazy" allow="fullscreen; encrypted-media; picture-in-picture" allowfullscreen title="Jaana Kavonius TikTok-video"></iframe>
                      </div>
                    </div>
                </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </template>

  <script>
    export default {
      name: 'Koronarokotepetokset',
      metaInfo: {
        title: 'Koronarokotepetokset',
      }
    }
  </script>

  <style scoped>
  p {
    margin-top: 1rem;
  }
  h1 {
      margin-top: 1rem;
      font-size: 1.8rem;
      font-weight: bold;
  }
  h2 {
      margin-top: 1rem;
      font-size: 1.5rem;
      font-weight: bold;
  }
  h3 {
      margin-top: 1rem;
      font-size: 1.2rem;
      font-weight: bold;
  }
  .videot {
    display: flex;
    flex-wrap: wrap;
    gap: 2rem;
    justify-content: center;
    margin-top: 2rem;
  }
  .video {
    width: 100%;
    max-width: 340px;
    aspect-ratio: 9 / 16;
  }
  .video iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
  #parallax-1 {
  
    background: url(../assets/1_elegant_BW_spotlight_background.jpg);
  
    background-attachment: fixed;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  
  
  </style>